const ESHOP_LIST_PATHS: Record<GLOBALS.Region, string> = {
  CZ: 'seznam-eshopu',
  PL: 'nasze-sklepy',
}

const ABSOLUTE_URL = /^[a-z][a-z\d+.-]*:/i

export const getEshopImageUrl = (
  path: string | null | undefined,
  origin: string,
  region: GLOBALS.Region
) => {
  if (!path) {
    return undefined
  }

  if (ABSOLUTE_URL.test(path)) {
    return path
  }

  if (path.startsWith('/')) {
    return `${origin}${path}`
  }

  // The eshop list API returns uploaded images relative to the Django eshop list page.
  return `${origin}/${ESHOP_LIST_PATHS[region]}/${path}`
}
